module.exports = __webpack_public_path__ + "img/product_87.d4215ac.webp";